import { ReactNode, useState } from 'react';
import { Stack, Typography, IconButton, Collapse, Divider } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

type CollapsibleSectionProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  showDivider?: boolean;
};

const CollapsibleSection = ({ title, children, defaultOpen = false, showDivider = false }: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Stack spacing={1}>
      {showDivider && <Divider />}
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='subtitle1'>{title}</Typography>
        <IconButton onClick={() => setIsOpen(!isOpen)} size='small'>
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Stack>
      <Collapse in={isOpen}>{children}</Collapse>
    </Stack>
  );
};

export default CollapsibleSection;
